import api from "app/lib/api";
import endpoints from "static/endpoints";
import { interpolate } from "utils/string";

export const getBillingAmounts = async () => {
  const { data } = await api.get(endpoints.billingAmount.billingAmounts);

  return data;
};

export const updateBillingAmount = async (id, payload) => {
  const url = interpolate(endpoints.billingAmount.billingAmountById, { id });

  const { data } = await api.put(url, payload);

  return data;
};
